module.exports = __webpack_public_path__ + "img/light-rain.af2d9728.png";